// The sound of a timeline episode: every ready spoken line, at its start, for its speaker's voice. Lines never overlap. A silent line makes no clip: the gap is its silence.
import { spokenLines, type TimelineEpisode } from "../model/timeline";
import type { AudioClip } from "./playback";

export function lineAudioClips(ep: TimelineEpisode, urlOf: (file: string) => string): AudioClip[] {
  return spokenLines(ep).filter(l => l.status === "ready" && l.audio && l.duration > 0)
    .map(l => ({ speaker: l.char ?? "", start: l.start, end: l.end, url: urlOf(l.audio!) }));
}
